import { CLASS_NAME } from 'constants/class-names'
import { Nullable } from 'constants/types'
import { ComponentBase } from 'utils/abstract-classes/component-base'

const { header: headerClass, drivingSubNav: subNav } = CLASS_NAME

export class SmoothHashScroll extends ComponentBase {
    /**
     * Initializer
     * Used hash link with smooth scroll
     */
    public constructor(private anchor: HTMLElement) {
        super()
        this.setEvent()
    }

    /**
     * Get the header-breaking__wrapper element
     * for scrolling logic
     * @return {Nullable<HTMLElement>}
     */
    private get breakingHeader(): Nullable<HTMLElement> {
        return document.querySelector<HTMLElement>(`.${headerClass.breaking}`)
    }

    /**
     * Get the header element
     * for scrolling logic
     * @return {Nullable<HTMLElement>}
     */
    private get header(): Nullable<HTMLElement> {
        return document.querySelector<HTMLElement>(`.${headerClass._}`)
    }

    /**
     * Get the subNav element on Driving
     * for scrolling logic
     * @return {Nullable<HTMLElement>}
     */
    private get subNav(): Nullable<HTMLElement> {
        return document.querySelector<HTMLElement>(`.${subNav.sticky}`)
    }

    /**
     * Get the scroll target: id matches
     * @param {string} id
     * @return {Nullable<HTMLElement>}
     */
    private getScrollTarget(id: string): Nullable<HTMLElement> {
        return document.getElementById(id)
    }

    /**
     * Set click event listener to a tag
     * @param {anchor} HTMLElement
     */
    private setEvent(): void {
        this.anchor.addEventListener('click', (event: MouseEvent) => {
            const id = this.anchor.getAttribute('href')?.substr(1) || ''
            const target = this.getScrollTarget(id)
            if (!target) {
                return
            }
            event.preventDefault()

            const header = this.header || { offsetHeight: 0 }
            const stickyHeader = this.breakingHeader || {
                offsetHeight: 0
            }
            const stickySubNav = this.subNav || {
                offsetHeight: 0
            }
            const scrollTop =
                target.offsetTop -
                header.offsetHeight -
                stickyHeader.offsetHeight -
                stickySubNav.offsetHeight

            window.scroll({
                top: scrollTop,
                behavior: 'smooth'
            })
        })
    }
}
